import React from 'react';
import { connect } from 'dva';
import curry from 'lodash-es/curry';
import get from 'lodash-es/get';
import PropTypes from 'prop-types';
import { SIDEBAR_SAVED_TABS } from '../../../lib/constants';
import MainLayersTabContent from '../Layers/MainLayersTabContent';
import MainOverlaysTabContent from '../Overlays/MainOverlaysTabContent';
import TabBar from '../../TabBar';

function LibraryContent(props) {
  const tabClicked = curry((tabName, e) => {
    props.dispatch({
      type: 'app/updateMetadata',
      payload: { savedLibraryTab: tabName }
    });

    props.dispatch({
      type: 'features/resetAllSelectedFeatures'
    });
  });

  const tabBarItems = {
    [SIDEBAR_SAVED_TABS.Library.Layers]: {
      title: 'Layers',
      component: <MainLayersTabContent />,
      onClick: tabClicked(SIDEBAR_SAVED_TABS.Library.Layers)
    },
    [SIDEBAR_SAVED_TABS.Library.Overlays]: {
      title: 'Overlays',
      component: <MainOverlaysTabContent />,
      onClick: tabClicked(SIDEBAR_SAVED_TABS.Library.Overlays)
    },
  };
  return (
    <>
      <TabBar tab={props.activeTab} tabBarItems={tabBarItems} />
      { tabBarItems[props.activeTab].component }
    </>
  );
}


LibraryContent.propTypes = {
  activeTab: PropTypes.string,
  allLayersLoading: PropTypes.bool,
};

export default connect((model)=>{
  const { allLayersLoading } = model.layers
  const { sidebarView } = model.app
  const { Layers } = SIDEBAR_SAVED_TABS.Library
  const activeTab = get(sidebarView, ['metadata', 'savedLibraryTab'], Layers)
  return {
    activeTab,
    allLayersLoading
  };
})(LibraryContent);
